import { isPageRotation } from "components/SmartSurveyor/ReviewPage/FloorPlanPanelWrapper/createDisplayTransform";
import { pageIndexOf } from "./planPatches";
import type { PlanPatch } from "./types";

// An unchanged map keeps its identity, so what reads it does not re-render.
const withPageValue = <Value>(
  values: Map<number, Value>,
  pageIndex: number,
  value: Value,
): Map<number, Value> => {
  if (values.get(pageIndex) === value) return values;
  const next = new Map(values);
  next.set(pageIndex, value);
  return next;
};

// Route meters come back through editRoutes, from the entry's own route rows.
export const applyPageChanges: PlanPatch = ({ plan, pages }) => {
  let next = plan;
  for (const { rowId, after } of pages) {
    if (after === null) continue;
    const pageIndex = pageIndexOf(next, rowId);
    if (pageIndex === null || !isPageRotation(after.rotation)) return null;
    next = {
      ...next,
      metersPerPdfPointByPageIndex: withPageValue(
        next.metersPerPdfPointByPageIndex,
        pageIndex,
        after.metersPerPdfPoint,
      ),
      metersPerPdfPointSourceByPageIndex: withPageValue(
        next.metersPerPdfPointSourceByPageIndex,
        pageIndex,
        after.metersPerPdfPointSource,
      ),
      rotationByPageIndex: withPageValue(
        next.rotationByPageIndex,
        pageIndex,
        after.rotation,
      ),
    };
  }
  return next;
};
